import { Injectable } from '@angular/core';
import { ApiServiceBase, RequestMethod } from '@api/abstracts';
import { environment } from '@environments/environment';
import { AvailableSlots } from '@shared/components/date-picker/model/available-slots';
import { normalizeAvailableSlots, RawAvailableSlots } from '@shared/components/date-picker/utils';
import { map, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AppointmentsSlotsService extends ApiServiceBase<AvailableSlots> {
  constructor() {
    super('timeslots', 'appointmentSlots', 'fournierWebservice');
  }

  getSlots(storeUuid: string, startDate: string, endDate: string): Observable<AvailableSlots> {
    const fournierNetwork = environment.integrations?.fournierWebservice?.network;
    const endpoint = `${this.endpoint}/store/${storeUuid}/dates/${startDate}/${endDate}?networkId=${fournierNetwork}`;

    return this.customRequest<RawAvailableSlots>(
      RequestMethod.GET,
      endpoint,
      undefined,
      undefined,
      undefined,
      false
    ).pipe(map(normalizeAvailableSlots));
  }
}
